import publicAxiosInstance from "./PublicAxiosInstance";
import awsGTWAxiosInstance from "./AWSGTWAxiosInstance";
import Constants from "./Constants";

class PublicAPI {
  static getProductsByCategoryName() {
    return publicAxiosInstance.get("/landing-products/LandingPage");
  }

  static getProductDetail(productNumber) {
    return awsGTWAxiosInstance.get(`/product-detail/${encodeURI(productNumber)}`);
  }

  static getSimplifiedProductDetail(productNumber) {
    return publicAxiosInstance.get(`/simplified-product-detail/${encodeURI(productNumber)}`);
  }

  static postRequestDemo(email) {
    const body = { email };
    return awsGTWAxiosInstance.post("/sw-public-api/reply-api/request-demo", body);
  }

  static postContactForm(fullName, email, message) {
    const body = { name: fullName, email, message };
    return awsGTWAxiosInstance.post("/sw-public-api/reply-api/submit-form", body);
  }

  static shopwareLogin(email) {
    return publicAxiosInstance.get(`/sw-login/${email}`);
  }

  static insertNewAddress(email, billingAddressJson, swContextToken) {
    publicAxiosInstance.defaults.headers.common[Constants.SW_CONTEXT_TOKEN] = swContextToken;
    return publicAxiosInstance.post(`/new-address/${email}`, billingAddressJson);
  }

  static deleteAddress(RoseAddressID) {
    const body = {
      RoseAddressID,
    };
    return publicAxiosInstance.post("/delete-address", body);
  }

  static buyMembership(membershipId, duration) {
    const body = {
      membershipId,
      duration,
    };
    return publicAxiosInstance.post("/buy-membership", body);
  }

  static deleteMembership(orderId, subscriptionId) {
    const body = {
      orderId,
      subscriptionId,
    };
    return publicAxiosInstance.post("/delete-membership-data", body);
  }

  static sendSuccessfulPaymentEmail(
    businessEmail,
    customerFirstName,
    orderNumber,
    subscriptionTotal,
    subscriptionTotalVATExcluded,
    subscriptionVAT,
  ) {
    const body = {
      businessEmail,
      customerFirstName,
      orderNumber,
      subscriptionTotal: subscriptionTotal.toString(),
      subscriptionTotalVATExcluded: subscriptionTotalVATExcluded.toString(),
      subscriptionVAT: subscriptionVAT.toString(),
    };
    return publicAxiosInstance.post("/successful-payment-email", body);
  }

  static updateOrder(orderId, paymentId) {
    const body = {
      orderId,
      paymentId,
    };
    return publicAxiosInstance.post("/update-order", body);
  }

  static getCatalogue(catalogueTitle) {
    return awsGTWAxiosInstance.get(`/catalogue-detail/${catalogueTitle}`);
  }

  static getPublicTopics() {
    return publicAxiosInstance.get("/public-filters");
  }
}

export default PublicAPI;
